import { Button } from '@mantine/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { archiveRecord } from '../services/CustomersService.ts';
import { Customer } from '../types';

interface ArchiveRecordButtonProps {
    customer: Customer;
}

export const ArchiveRecordButton = ({ customer }: ArchiveRecordButtonProps) => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: () => archiveRecord(customer.id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['customers'] });
        }
    });

    return (
        <Button
            size="xs"
            variant="outline"
            color="orange"
            onClick={() => mutation.mutate()}
            loading={mutation.isPending}
            disabled={customer.status === 'ARCHIVED'}
        >
            Archive
        </Button>
    );
};